import ApiService from "./api.service";

const WholesalerService = {
  async wholesalerSelect() {
    try {
      return await ApiService.get("wholesalers-select");
    } catch (error) {
      return error.response;
    }
  },
  async wshBankStatement(data) {
    try {
      return await ApiService.get(
        `wsh/user/bank_statement/${data.page ?? 0}?${data.query ?? ""}`,
      );
    } catch (e) {
      console.log(e);
    }
  },

  async wholesalerSearch(id, query, page = 0, year) {
    try {
      const search = query ? encodeURIComponent(query) : "no-query";
      const resolvedYear = year || "";
      const params = new URLSearchParams({ page: String(page) });
      params.set("year", String(resolvedYear));

      let response = await ApiService.get(
        `users/${id}/search/${search}?${params.toString()}`,
      );
      if (response.status == 200) {
        return response.data;
      }
    } catch (e) {
      return e.response;
    }
  },

  async wholesalerSummary(id) {
    try {
      let response = await ApiService.get(`users/${id}/summary`);
      if (response.status == 200) {
        return response.data;
      }
    } catch (e) {
      return e.response;
    }
  },

  async wholesalers() {
    try {
      let response = await ApiService.get(`wholesalers`);
      if (response.status == 200) {
        return response.data;
      }
    } catch (e) {
      return e.response;
    }
  },

  async vouchers(id) {
    try {
      let response = await ApiService.get(`users/vouchers/${id}`);
      if (response.status == 200) {
        return response.data;
      }
    } catch (e) {
      return e.response;
    }
  },
};

export { WholesalerService };
